class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartDrawer = this.closest('cart-drawer');
      const currCbVarId = this.dataset.cb_var_id;
      let currIndex = this.dataset.index;
      const currKey = this.dataset.key;

      const fetchedCartData = cartDrawer.getCart();
      Promise.all([fetchedCartData]).then((values) => {
        if (values.length === 0) {
          return;
        }
  
        const cartData = values[0];
        let nothingUpdated = true;

        for (let index = 0; index < cartData.items.length; index++) {
          let propsToDel = [];
          let newPros = [];
          let idToUpd = cartData.items[index].id;
          let keyToUpd = cartData.items[index].key;
          let needToUpdate = false;

          for (let attr_key in cartData.items[index].properties) {
            if (cartData.items[index].properties[attr_key] == currCbVarId) {
              needToUpdate = true;
              let currGPIdx = attr_key.replace('__Product ', '').replace(' Variant ID', '');
              propsToDel.push(currGPIdx);
            } else {
              newPros[attr_key] = cartData.items[index].properties[attr_key];
            }
          }

          if (needToUpdate) {
            nothingUpdated = false;
            let newNewPros = {};
            for (let k = 0; k < propsToDel.length; k++) {
              for (let new_attr_key in newPros) {
                if (propsToDel[k] != new_attr_key) {
                  newNewPros[new_attr_key] = newPros[new_attr_key];
                }
              }
            }

            let needToDelGP = true;
            for (let new_new_attr_key in newNewPros) {
              if (new_new_attr_key.includes('__Product ')) {
                needToDelGP = false;
              }
            }

            if (needToDelGP) {
              // delete GP
              // console.log('delete GP', newNewPros, propsToDel);
              const body = JSON.stringify({ id: keyToUpd, quantity: 0 });
              fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
                .then((response) => response.text())
                .then((response) => {
                  response = JSON.parse(response);

                  for (let cart_idx = 0; cart_idx < response.items.length; cart_idx++) {
                    if (response.items[cart_idx].key == currKey) {
                      currIndex = cart_idx + 1;
                    }
                  }
                  cartDrawer.updateQuantity(currIndex, 0);
                })
                .catch((e) => {
                  window.console.error(error);
                });
            } else {
              // update GP
              // console.log('update GP', newNewPros, propsToDel);
              const body = JSON.stringify({ id: keyToUpd, properties: newNewPros });
              fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
                .then((response) => response.json())
                .then((response) => {
                  cartDrawer.updateQuantity(currIndex, 0);
                })
                .catch((e) => {
                  window.console.error(error);
                });
            }
          }
        }

        if (nothingUpdated) {
          cartDrawer.updateQuantity(currIndex, 0);
        }
      })
      .catch((error) => {
        window.console.error(error);
      });
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300))
  }
}

customElements.define('cart-note', CartNote);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.getElementById('cart-drawer');
    this.cartDrawerOpen = document.querySelector('[data-js-cart-drawer="cartDrawerOpen"]');
    this.cartDrawerClose = document.querySelector('[data-js-cart-drawer="cartDrawerClose"]');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.itemCountHolder = document.querySelector('[data-js-cart-item-count]');

    this.lineItemStatusElement = document.getElementById('cart-drawer-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.drawer.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.querySelectorAll('[data-js-cart-drawer="cartDrawerClose"]').forEach((closeButton) => {
      this.activeElement = document.activeElement || this.cartDrawerOpen;
      closeButton.addEventListener('click', this.close.bind(this));
    });

    document.querySelectorAll('[data-js-cart-drawer="cartDrawerOpen"]').forEach((openButton) => {
      openButton.addEventListener('click', this.handleDrawerOpen.bind(this))
    });

    document.querySelectorAll('#cb-add-gift-wrap-btn').forEach((giftButton) => {
      giftButton.addEventListener('click', this.addGiftWrapping.bind(this));
    });

    this.initGiftWrappingProducts();
    
  }

  onChange(event) {
    if (event.target.value === '0' || event.target.value === 0) {
      event.preventDefault();
      const cartDrawer = event.target.closest('cart-drawer');
      const currCbVarId = event.target.dataset.cb_var_id;
      let currIndex = event.target.dataset.index;
      const currKey = event.target.dataset.key;

      const fetchedCartData = cartDrawer.getCart();
      Promise.all([fetchedCartData]).then((values) => {
        if (values.length === 0) {
          return;
        }
  
        const cartData = values[0];
        let nothingUpdated = true;

        for (let index = 0; index < cartData.items.length; index++) {
          let propsToDel = [];
          let newPros = [];
          let idToUpd = cartData.items[index].id;
          let keyToUpd = cartData.items[index].key;
          let needToUpdate = false;

          for (let attr_key in cartData.items[index].properties) {
            if (cartData.items[index].properties[attr_key] == currCbVarId) {
              needToUpdate = true;
              let currGPIdx = attr_key.replace('__Product ', '').replace(' Variant ID', '');
              propsToDel.push(currGPIdx);
            } else {
              newPros[attr_key] = cartData.items[index].properties[attr_key];
            }
          }

          if (needToUpdate) {
            nothingUpdated = false;
            let newNewPros = {};
            for (let k = 0; k < propsToDel.length; k++) {
              for (let new_attr_key in newPros) {
                if (propsToDel[k] != new_attr_key) {
                  newNewPros[new_attr_key] = newPros[new_attr_key];
                }
              }
            }

            let needToDelGP = true;
            for (let new_new_attr_key in newNewPros) {
              if (new_new_attr_key.includes('__Product ')) {
                needToDelGP = false;
              }
            }

            if (needToDelGP) {
              // delete GP
              // console.log('delete GP', newNewPros, propsToDel);
              const body = JSON.stringify({ id: keyToUpd, quantity: 0 });
              fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
                .then((response) => response.text())
                .then((response) => {
                  response = JSON.parse(response);

                  for (let cart_idx = 0; cart_idx < response.items.length; cart_idx++) {
                    if (response.items[cart_idx].key == currKey) {
                      currIndex = cart_idx + 1;
                    }
                  }
                  cartDrawer.updateQuantity(currIndex, 0);
                })
                .catch((e) => {
                  window.console.error(error);
                });
            } else {
              // update GP
              // console.log('update GP', newNewPros, propsToDel);
              const body = JSON.stringify({ id: keyToUpd, properties: newNewPros });
              fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
                .then((response) => response.json())
                .then((response) => {
                  cartDrawer.updateQuantity(currIndex, 0);
                })
                .catch((e) => {
                  window.console.error(error);
                });
            }
          }
        }

        if (nothingUpdated) {
          cartDrawer.updateQuantity(currIndex, 0);
        }
      })
      .catch((error) => {
        window.console.error(error);
      });
    } else {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
    
  }

  /**
   * Open the cart-drawer
   */
  handleDrawerOpen() {
    if (theme.pageType === 'cart') {
      return;
    }
    this.open();
  }

  /**
   * Triggered whenever product-form was submitted and item was added to cart
   * @param  {Object} Added to cart item data
   */
  handleAddedItem(addedItemResponse) {
    const fetchedCartData = this.getCart();
    this.handleCartData(fetchedCartData, addedItemResponse);
  }

  /**
   * Get Cart data from Shopify Ajax API
   * @return {Object} Promise
   */
  getCart() {
    return new Promise((resolve, reject) => {
      fetch(`${routes.ajax_api}`)
        .then((response) => response.json())
        .then((response) => {
          if (response) {
            resolve(response);
            return;
          }

          reject(response);
        })
        .catch((e) => {
          window.console.error(error);
        });
    });
  }

  /**
   * Handle cart data after the response from Shopify Ajax API
   * @param  {Object} Promise
   * @param  {Object} Added to cart item data
   */
  handleCartData(promise, addedItemResponse = false) {
    Promise.all([promise]).then((values) => {
      if (values.length === 0) {
        return;
      }

      const cartData = values[0];

      if (addedItemResponse !== false) {
        const line = cartData.items.map((item, index) => {
          if (item.id === addedItemResponse.id) {
            return index;
          }
        });

        this.renderContents(cartData, addedItemResponse, line, '', false);
      }
    })
    .catch((error) => {
      window.console.error(error);
    });
  }

  /**
   * Get sections to render
   * @return {Object}
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: document.getElementById('cart-drawer').dataset.id,
        selector: '.js-contents',
        selectorWrappingItems: '.js-contents-wi',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.renderContents(parsedState, false, line, name, true);

        if (quantity == 0) {
          this.updateTrappedFocus();
        }
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-drawer-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  addGiftWrapping() {
    let idData = document.querySelector('#cb-add-gift-wrap-btn');

    if (idData !== null) {
      let id = idData.dataset.gwpVarId;
      let quantity = 1;
      let properties = {};
      properties['__gift_wrapping'] = true;
      let wrappingItems = document.querySelectorAll('.cb-wrapping-item:checked');

      for (let idx = 0; idx < wrappingItems.length; idx++) {
        let wrappingIterator = idx + 1;
        properties['' + wrappingIterator] = wrappingItems[idx].dataset.wiName;
        properties['__Product ' + wrappingIterator + ' Variant ID'] = wrappingItems[idx].dataset.wiVarId;
        properties['__time'] = new Date().toLocaleTimeString();
      }

      if (document.querySelector('#wrapping-text').value !== '') {
        properties['Gift Message'] = document.querySelector('#wrapping-text').value;
      }

      const body = JSON.stringify({
        id,
        quantity,
        properties,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
  
          this.handleAddedItem(parsedState);

          document.querySelector('#wrapping-text').value = '';
          document.querySelector('#wrapping-text').dispatchEvent(new KeyboardEvent('keyup'));
          document.querySelector('#ModalClose-popup_CGLVdm.cb-wrapping-modal-close').click();
          
        }).catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('cart-drawer-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }
    
  }

  initGiftWrappingProducts() {
    document.querySelectorAll('.cb-wrapping-item').forEach((wrappingProduct) => {
      wrappingProduct.addEventListener('change', this.updateAddGiftWrappingBtn.bind(this));
    });
  }

  updateAddGiftWrappingBtn() {
    if (document.querySelectorAll('.cb-wrapping-item:checked').length > 0) {
      document.querySelector('#cb-add-gift-wrap-btn').removeAttribute("disabled");
    } else {
      document.querySelector('#cb-add-gift-wrap-btn').setAttribute("disabled", true);
    }

    // if(jQuery('.cb-wrapping-item').is(':checked')) {
    //   jQuery('#cb-add-gift-wrap-btn').removeAttr('disabled')
    // } else {
    //   jQuery('#cb-add-gift-wrap-btn').attr('disabled', true)
    // }
  }

  open() {
    this.activeElement = document.activeElement || this.cartDrawerOpen;
    this.drawer.classList.add('animate', 'active');

    this.drawer.addEventListener('transitionend', () => {
      this.drawer.focus();
      trapFocus(this.drawer, this.cartDrawerClose);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.drawer.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  /**
   * Render Contents
   * @param  {Object} Cart data
   * @param  {Object/Boolean} Added to cart item data / False
   * @param  {Number}  Line item index
   * @param  {String}  Line item input name
   * @param  {Boolean} Whether Cart-drawer is opened
   */
  renderContents(parsedState, addedItemResponse = false, line, name, isDrawerOpened = false) {
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    this.itemCountHolder.innerText = parsedState.item_count;
    this.itemCountHolder.classList.toggle('is-active', parsedState.item_count > 0);
    const cartFooter = document.getElementById('cart-drawer-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section => {
      let state = parsedState;

      if (addedItemResponse !== false) {
        state = addedItemResponse;
      }

      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML =
        this.getSectionInnerHTML(state.sections[section.section], section.selector);

      const elementToReplaceWi =
        document.querySelector(section.selectorWrappingItems);

      elementToReplaceWi.innerHTML =
        this.getSectionInnerHTML(state.sections[section.section], section.selectorWrappingItems);

      this.initGiftWrappingProducts();
      document.querySelector('#cb-add-gift-wrap-btn').setAttribute("disabled", true);
    }));

    this.updateLiveRegions(line, parsedState.item_count);
    const lineItem =  document.getElementById(`CartDrawerItem-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
    this.disableLoading();

    if (!isDrawerOpened) {
      if (this.header) this.header.reveal();
      this.open();
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    if (line == '' || !line) {
      return;
    }

    if (this.currentItemCount === itemCount) {
      document.getElementById(`CartDrawerItem-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`CartDrawerItem-quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-drawer-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  enableLoading(line) {
    document.getElementById('cart-drawer').classList.add('cart-drawer--disabled');
    this.querySelectorAll(`#CartDrawerItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('cart-drawer').classList.remove('cart-drawer--disabled');
  }

  handleBodyClick(event) {
    const target = event.target;
    const isNotDrawer = (target !== this.drawer) && (!target.closest('cart-drawer'));
    const isNotGiftWrapping = ![...target.classList].includes('cb-wrapping-modal-close');
    const isNotButtonOpen = target !== this.cartDrawerOpen && !target.closest('[data-js-cart-drawer="cartDrawerOpen"]');
    const isCloseButton = (target === this.cartDrawerClose) || (target.closest('[data-js-cart-drawer="cartDrawerClose"]'));

    if (isNotDrawer && isNotButtonOpen && isNotGiftWrapping || isCloseButton) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateTrappedFocus() {
    removeTrapFocus(document.activeElement);

    setTimeout(() => {
      this.setActiveElement(this.cartDrawerClose || this.cartDrawerOpen);
      this.drawer.focus();
      trapFocus(this.drawer, this.cartDrawerClose);
    });
  }
}

customElements.define('cart-drawer', CartDrawer);
